import { patchState, signalStore, withHooks, withMethods, withProps, withState } from '@ngrx/signals';
import { AppState } from '@models/app-state.model';
import { inject } from '@angular/core';
import { LocalStorageService } from '@services/local-storage.service';
import { User } from '@models/user';

const stateKey = 'lsapState';

const initialState = {
  appState: new AppState(),
  language: 'ua',
};

export const appStateStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withProps(() => ({
    localStorageService: inject(LocalStorageService),
  })),
  withMethods(({ localStorageService, ...store }) => ({
    setUrl(url: string) {
      patchState(store, (state) => {
        const newState = {
          appState: { ...state.appState, url },
        };
        localStorageService.setItem(stateKey, newState.appState);
        return newState;
      });
    },
    setToken(token: string) {
      patchState(store, (state) => {
        const newState = {
          appState: { ...state.appState, token: token },
        };
        localStorageService.setItem(stateKey, newState.appState);
        return newState;
      });
    },
    setUser(user: User) {
      patchState(store, (state) => {
        const newState = {
          appState: { ...state.appState, user: user },
        };
        localStorageService.setItem(stateKey, newState.appState);
        return newState;
      });
    },
    setSessionTimeout(timeout: string) {
      patchState(store, (state) => {
        const newState = {
          appState: { ...state.appState, sessionTimeout: timeout },
        };
        localStorageService.setItem(stateKey, newState.appState);
        return newState;
      });
    },
    setAppState(appState: AppState) {
      patchState(store, () => ({ appState }));
      localStorageService.setItem(stateKey, appState);
    },
    setLanguage(language: string) {
      patchState(store, (state) => ({
        language: language,
      }));
    },
    removeState() {
      patchState(store, (state) => ({
        appState: new AppState(),
      }));
      localStorageService.setItem(stateKey, store.appState());
    },
  })),
  withHooks({
    onInit({ localStorageService, ...store }) {
      store.setAppState(localStorageService.getItem<AppState>(stateKey) || new AppState());
    },
  }),
);
